import React from "react";
import "./LegalPage.css";
import LegalPage from "./LegalPage";

export default function Privacy() {
    return <LegalPage ns="privacy" />;
}
